import * as React from "react";
import {
  AppBar,
  Box,
  Button,
  Toolbar,
  IconButton,
  Menu,
  Container,
  MenuItem,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "../assets/Images/Dajoo.png";

const navLinks = [
  { text: "Home", section: "home" },
  { text: "How it Works", section: "howItWorks" },
  { text: "Features", section: "features" },
  { text: "Terms & Conditions", href: "/terms-and-conditions" },
  { text: "Privacy Policy", href: "/privacy-policy" },
];

const ResponsiveAppBar = ({ scrollToSection }) => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="sticky" sx={{ bgcolor: "white", boxShadow: "none" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Logo */}
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{ mr: 2, mt: 1 }}
          >
            <img
              alt="logo"
              src={Logo}
              style={{ width: "120px", borderRadius: "15px" }}
            ></img>
          </Typography>

          {/* Mobile Menu Icon */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none", justifyContent: "end" },
            }}
          >
            <IconButton size="large" onClick={handleOpenNavMenu} color="black">
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorElNav}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {navLinks.map((link, index) => (
                <MenuItem
                  key={index}
                  component="a"
                  href={link.href || "/"}
                  onClick={(e) => {
                    if (link.section && scrollToSection) {
                      e.preventDefault();
                      scrollToSection(link.section);
                    }
                    handleCloseNavMenu();
                  }}
                >
                  {link.text}
                </MenuItem>
              ))}

              {/* ✅ Login Button in Mobile Menu */}
              <MenuItem onClick={handleCloseNavMenu}>
                <Button
                  variant="outlined"
                  sx={{
                    width: "100%",
                    borderColor: "#171717",
                    color: "#171717",
                  }}
                >
                  Login
                </Button>
              </MenuItem>
            </Menu>
          </Box>

          {/* Desktop Navigation */}
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {navLinks.map((link, index) =>
              link.href ? (
                <Button
                  key={index}
                  href={link.href}
                  sx={{ my: 2, color: "#171717", display: "block", mx: 1 }}
                >
                  {link.text}
                </Button>
              ) : (
                <Button
                  key={index}
                  component="a"
                  href={link.href || "/"}
                  onClick={(e) => {
                    if (link.section && scrollToSection) {
                      e.preventDefault();
                      scrollToSection(link.section);
                    }
                  }}
                  sx={{ my: 2, color: "#171717", display: "block", mx: 1 }}
                >
                  {link.text}
                </Button>
              ),
            )}
          </Box>

          {/* ✅ Login Button for Desktop */}
          <Box sx={{ flexGrow: 0, display: { xs: "none", md: "block" } }}>
            <Button
              variant="outlined"
              sx={{ borderColor: "#171717", color: "#171717" }}
            >
              Login
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default ResponsiveAppBar;
